<template>
  <ValidationProvider :name="name" :rules="rules" v-slot="{ classes }" slim>
    <input
      :type="type"
      :placeholder="placeholder"
      :value="value"
      :name="name"
      :readonly="readonly"
      :maxlength="maxlength"
      :class="[classes, {'input-bold' : value != null && value != ''}]"
      @click="$emit('click')"
      @input="$emit('input', $event.target.value)"
      autocapitalize="off"
    />
    <!-- :class="{'invalid': invalid && touched}" -->
  </ValidationProvider>
</template>
<script>
export default {
  props: ['name', 'rules', 'value', 'type', 'placeholder', 'readonly', 'maxlength'],
  watch: {
    value(val) {
      this.value = val
      this.$forceUpdate()
    }
  },
  created() {
  }
}
</script>
<style lang="scss" scoped>
@import '@/design';

input {
  border-radius: 4px;
  border: solid 1px #d7e1ea;
  background-color: $white;
  font-size: 16px;
  font-weight: 300;
  height: 44px;
  padding-left: 10px;
  width: 100%;

  &::placeholder,
  &:-moz-placeholder,
  &::-moz-placeholder,
  &:-ms-input-placeholder,
  &:-ms-input-placeholder,
  &::-webkit-input-placeholder {
    color: #8a94a2;
  }
}

input:read-only {
  background-color: #edf4fc;
  color: #8a94a2;
}
</style>
